import { ISavedFilterIdsSetAction } from './types';
import { AT_SAVED_FILTER_IDS_SET } from './constants';

export const savedFilterIdsSet = (
    savedFilterIds: number[]
): ISavedFilterIdsSetAction => ({
    type: AT_SAVED_FILTER_IDS_SET,
    savedFilterIds
});
